var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 300,
    fill: "#012169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L600,300 M600,0 L0,300",
    stroke: "white",
    strokeWidth: 60
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L600,300 M600,0 L0,300",
    stroke: "#C8102E",
    strokeWidth: 40
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0 V300 M0,150 H600",
    stroke: "white",
    strokeWidth: 100
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0 V300 M0,150 H600",
    stroke: "#C8102E",
    strokeWidth: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.fd149c6212d3f8921840a1f92ff3032a.svg";
export { ForwardRef as ReactComponent };